const formatNumberToLocale = (value: number, locale: string = 'fr-FR'): string => {
  const formatter = new Intl.NumberFormat(locale)

  return formatter.format(value)
}

export { formatNumberToLocale }
